export const FileTypes = {
  IMAGE: ['PNG', 'JPG', 'JPEG', 'WEBP', 'AVIF', 'BMP', 'GIF', 'SVG', 'ICO', 'TIFF', 'TIF'],
  PDF: ['PDF'],
  XML: ['XML'],
  LINK: ['LINK'],
  ALIVE_COR_ATC: ['ATC'],
  VIDEO: ['MP4', 'MOV', 'WEBM', 'OGV', 'AVI', 'MKV', 'M4V', '3GP', 'FLV'],
  AUDIO: ['MP3', 'WAV', 'OGG', 'AAC', 'FLAC', 'M4A', 'OPUS', 'WEBM', 'WMA', 'AIFF'],
};

export enum Viewer {
  AliveCorSingleLead = 'AliveCor-SingleLead',
  AliveCorSixLead = 'AliveCor-SixLead',
  MedDream = 'meddream',
  Brit = 'brit',
  Ambra = 'ambra',
  Techcyte = 'techcyte',
  Pathozoom = 'pathozoom',
  Aiforia = 'aiforia',
}

export const LOCALSTORAGE_KEY_ECG_VIEWER_WRAPPING = 'ecg-viewer-wrapping';

export const DEFAULT_MULTI_MONITOR_ENABLED = false;

// Browser native video formats with codec support
export const BROWSER_NATIVE_VIDEO_FORMATS = {
  MP4: { container: 'video/mp4', codecs: ['avc1.42E01E', 'avc1.4D401E', 'avc1.64001E', 'mp4a.40.2'] },
  WEBM: { container: 'video/webm', codecs: ['vp8', 'vp9', 'av01', 'opus', 'vorbis'] },
  OGG: { container: 'video/ogg', codecs: ['theora', 'vorbis'] },
};

// Browser native audio formats
export const BROWSER_NATIVE_AUDIO_FORMATS = {
  MP3: { container: 'audio/mpeg' },
  WAV: { container: 'audio/wav' },
  OGG: { container: 'audio/ogg', codecs: ['vorbis', 'opus'] },
  AAC: { container: 'audio/aac' },
  WEBM: { container: 'audio/webm', codecs: ['opus', 'vorbis'] },
  FLAC: { container: 'audio/flac' },
};
